// ISO date string → "24 May 2026"
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
}

// ISO datetime string → "24 May 2026, 10:15"
export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

// "2026-05-24" (DateOnly from API) → Date object (local midnight, for day-count display)
export function parseDateOnly(s: string): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

// "2026-05-24" → end-of-day UTC (23:59:59Z), matching the backend's TimeOnly.MaxValue.
// Use this for escalation threshold calculations, not for display.
export function parseDueDateEndOfDay(s: string): Date {
  return new Date(s + 'T23:59:59Z');
}

// Days from today until the given ISO date string (negative = past)
export function daysUntil(iso: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = parseDateOnly(iso);
  return Math.round((target.getTime() - today.getTime()) / 86_400_000);
}

// "2026-05-24" → Monday of that week as "2026-05-18"
export function weekLabel(iso: string): string {
  return `w/c ${formatDate(iso)}`;
}
